<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>
<h2 id="title">Questionari da visionare</h2>
<div class="container && mat-elevation-z5">
<ng-container>
  <div id="container">
    <div *ngIf="notReady==false">
      <mat-form-field class="filtro">
        <mat-label>Nome e cognome</mat-label>
        <input matInput id="input-filtro" (keyup)="applyFilter($event)" #input>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-types-selection">
        <mat-label>Filtra tipo</mat-label>
        <mat-select [formControl]="typesControl"
                    (selectionChange)="applyFilterType($event.value)"
                    panelClass="myPanelClass">
          <mat-option *ngFor="let type of typesList" [value]="type">{{type}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="selection.hasValue()" id="segnaLetto">
        <button mat-raised-button color="primary" (click)="markAsReadQuestionnaires()">Segna come letti</button>
      </div>
    </div>


    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null"
                          [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(row) : null"
                          [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="namePatient">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Nome paziente </th>
          <td mat-cell *matCellDef="let element"> {{element.namePatient}} </td>
        </ng-container>

        <ng-container matColumnDef="surnamePatient">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Cognome paziente </th>
          <td mat-cell *matCellDef="let element"> {{element.surnamePatient}} </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Tipo </th>
          <td mat-cell *matCellDef="let element"> {{element.type}} </td>
        </ng-container>

      <ng-container matColumnDef="finalScore">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Score </th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="element.finalScore!=null"> {{element.finalScore}} </div>
          <div *ngIf="element.finalScore==null"> - </div>
        </td>
      </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Data </th>
          <!-- lo split serve perche non voglio vedere l'orario. La data mi arriva in formato aaaa/mm/ggTorario-->
          <td mat-cell *matCellDef="let element"> {{element.date.split("T")[0]}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let questionnaire; columns: displayedColumns;"
            (click)="showQuestionnaire(questionnaire)">
        </tr>
      </table>
    <div *ngIf="notReady==true">
      <mat-progress-bar mode="query"></mat-progress-bar>
    </div>
    <span>
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </span>
  </div>
</ng-container>
</div>
